// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";

Game.PARTICLE_CAP = 280;

Game.prototype.spawnParticles = function (x, y, n, color, speed, life, opts) {
    const cap = Game.PARTICLE_CAP;
    if (this.particles.length >= cap) return;
    const budget = Math.min(n, cap - this.particles.length);
    for (let i = 0; i < budget; i++) {
      const a = rand(0, TAU), sp = rand(speed * 0.3, speed);
      this.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
        rand(life * 0.6, life), color, rand(2, 5), opts));
    }
  }

Game.prototype.ringBurst = function (x, y, radius, color) {
    const n = 26;
    for (let i = 0; i < n; i++) {
      const a = (i / n) * TAU;
      this.particles.push(new Particle(x, y, Math.cos(a) * radius * 2.2, Math.sin(a) * radius * 2.2,
        0.35, color, 4, { kind: "spark" }));
    }
  }

Game.prototype.spawnShockwave = function (x, y, r1, color, opts) {
    const o = opts || EMPTY_OPTS;
    this.shockwaves.push({
      x, y, color,
      t: 0,
      life: o.life || 0.4,
      r0: o.r0 || 0,
      r1,
      width: o.width || 4,
      glow: o.glow !== false,
    });
  }

Game.prototype.spawnBloomRipple = function (x, y, kind) {
    if (!this.bloomRipples) this.bloomRipples = [];
    const maxR = this.platformRadius || 950;
    this.bloomRipples.push({
      x, y, kind: kind || "light", t: 0, life: 0.95, maxR,
    });
  }

Game.prototype.updateBloomRipples = function (dt) {
    if (!this.bloomRipples?.length) return;
    for (const r of this.bloomRipples) r.t += dt;
    compact(this.bloomRipples, r => r.t < r.life);
  }

Game.prototype.spawnArmPop = function (x, y, maxR, color, opts) {
    const o = opts || EMPTY_OPTS;
    if (!this.armPops) this.armPops = [];
    this.armPops.push({
      x, y, maxR: maxR || 120, color: color || "#8ef0a8",
      fillCol: o.fillCol || "#c8ffd8",
      t: 0, life: o.life || 0.42,
    });
  }

Game.prototype.updateArmPops = function (dt) {
    if (!this.armPops?.length) return;
    for (const p of this.armPops) p.t += dt;
    compact(this.armPops, p => p.t < p.life);
  }

Game.prototype.castFXAim = function (f) {
    if (f.a != null && Number.isFinite(f.a)) return f.a;
    let best = null, bestD = 1e9;
    for (const p of this.players) {
      if (!p.alive) continue;
      const d = Math.hypot(p.x - f.x, p.y - f.y);
      if (d < bestD) { bestD = d; best = p; }
    }
    if (best && bestD < 80) return best.aim ?? best.facing ?? 0;
    return 0;
  }

Game.prototype.spawnSpellSpritePop = function (x, y, spellId, phase, opts = EMPTY_OPTS) {
    if (!spellSpritePhaseReady(spellId, phase)) return;
    const life = opts.life != null ? opts.life : spellSpritePhaseLife(spellId, phase);
    const worldR = opts.worldR != null ? opts.worldR
      : (phase === "cast" ? spellSpritePhaseOpt(spellId, "cast", "Radius", 13) : null);
    let px = x, py = y, ang = opts.ang, layer = "behind";
    if (phase === "cast") {
      const pose = spellCastPopPose(spellId, x, y, opts.ang);
      px = pose.x;
      py = pose.y;
      ang = pose.ang;
      layer = spellCastPopLayer(spellId);
    }
    if (!this.spellSpritePops) this.spellSpritePops = [];
    this.spellSpritePops.push({
      x: px, y: py, spellId, phase,
      t: 0, life,
      drawSz: opts.drawSz != null ? opts.drawSz : spellSpritePhaseDrawSz(spellId, phase, worldR),
      ang,
      layer,
    });
  }

Game.prototype.updateSpellSpritePops = function (dt) {
    if (!this.spellSpritePops?.length) return;
    for (const p of this.spellSpritePops) p.t += dt;
    compact(this.spellSpritePops, p => p.t < p.life);
  }

Game.prototype.drawSpellSpritePops = function (layer) {
    const c = this.ctx;
    if (!this.spellSpritePops?.length) return;
    c.save();
    for (const pop of this.spellSpritePops) {
      if ((pop.layer || "behind") !== layer) continue;
      const pspec = spellSpritePhaseSpec(pop.spellId, pop.phase);
      const n = (pspec && pspec.frames) || 1;
      const p = clamp(pop.t / pop.life, 0, 1);
      const fi = clamp(Math.min(n - 1, Math.floor(p * n)), 0, n - 1);
      const fadeAt = spellSpritePhaseOpt(pop.spellId, pop.phase, "FadeStart", 0.72);
      const fade = p > fadeAt ? (1 - p) / (1 - fadeAt) : 1;
      c.save();
      c.translate(pop.x, pop.y);
      this.upright();
      if (pop.ang != null) c.rotate(pop.ang);
      drawSpellSprite(c, pop.spellId, pop.t, pop.drawSz, fade, fi, pop.phase);
      c.restore();
    }
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.drawFireballProjectile = function (c, pr, ang, t) {
    const r = pr.radius || 8;
    const col = pr.color || (SPELLS[pr.spellId] && SPELLS[pr.spellId].color) || "#ff7a2f";
    if (fireballSpriteFXEnabled(pr.spellId) && spellSpritePhaseReady(pr.spellId, "flight")) {
      const fi = spellSpriteAnimFrame(pr.spellId, "flight", t);
      const sz = spellSpritePhaseDrawSz(pr.spellId, "flight", r);
      c.rotate(ang);
      if (drawSpellSprite(c, pr.spellId, t, sz, null, fi, "flight")) return;
    }
    this.glowOrb(c, r, col, ang, "#fff0d0");
  }

Game.prototype.drawPoisonSprayProjectile = function (c, pr, ang, t) {
    const r = pr.radius || 8;
    const pulse = 0.85 + 0.15 * Math.sin(t * 14 + pr.id * 0.3);
    c.save();
    c.rotate(ang);
    this.glowOrb(c, r * pulse, "#6a8a30", 0, "#c8d040");
    c.globalCompositeOperation = "lighter";
    c.fillStyle = "rgba(200,208,64,0.35)";
    c.beginPath();
    c.arc(r * 0.15, 0, r * 0.55, 0, TAU);
    c.fill();
    c.restore();
  }

Game.prototype.commitBloomPodDetonate = function (x, y, blastR) {
    const key = `${Math.round(x * 0.25)}:${Math.round(y * 0.25)}`;
    if (!this._bloomDetKeys) this._bloomDetKeys = new Set();
    if (this._bloomDetKeys.has(key)) return;
    this._bloomDetKeys.add(key);
    setTimeout(() => this._bloomDetKeys.delete(key), 2500);
    this.spawnArmPop(x, y, blastR, "#8ef0a8", { fillCol: "#c8ffd8" });
    this.natureBurst(x, y, 26, 1.2);
    this.spawnParticles(x, y, 14, "#c8ffd8", 170, 0.45, { kind: "spark" });
    this.spawnShockwave(x, y, blastR, "#8ef0a8", { life: 0.5, width: 8 });
    this.spawnShockwave(x, y, blastR * 0.67, "#c8ffd8", { life: 0.32, width: 4 });
  }

Game.prototype.spawnBeam = function (x0, y0, x1, y1, color, width) {
    this.beams.push({ x0, y0, x1, y1, t: 0, life: 0.22, color, seed: Math.random() * 1000, width: width || 0 });
  }

Game.prototype.spawnVoidBeam = function (x0, y0, x1, y1, halfW) {
    this.beams.push({ x0, y0, x1, y1, t: 0, life: 0.34, kind: "void", seed: Math.random() * 1000, width: (halfW || 20) * 2 });
  }

Game.prototype.fireBurst = function (x, y, n, scale) {
    const s = scale || 1;
    for (let i = 0; i < n; i++) {
      const a = rand(0, TAU), sp = rand(60, 260) * s;
      const hot = Math.random() < 0.5;
      this.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
        rand(0.3, 0.7), hot ? "#ffd479" : "#ff7a2f", rand(2.5, 5) * s, { kind: "glow", grav: -40 }));
    }
    for (let i = 0; i < n * 0.4; i++) {
      const a = rand(0, TAU), sp = rand(20, 90) * s;
      this.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
        rand(0.5, 1.0), "#3a2a26", rand(4, 8) * s, { kind: "smoke", grav: -60, drag: 0.9 }));
    }
  }

Game.prototype.natureBurst = function (x, y, n, scale) {
    const s = scale || 1;
    for (let i = 0; i < n; i++) {
      const a = rand(0, TAU), sp = rand(60, 260) * s;
      const light = Math.random() < 0.55;
      this.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
        rand(0.3, 0.7), light ? "#c8ffd8" : "#8ef0a8", rand(2.5, 5) * s, { kind: "glow", grav: -40 }));
    }
    for (let i = 0; i < n * 0.35; i++) {
      const a = rand(0, TAU), sp = rand(20, 90) * s;
      this.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
        rand(0.5, 1.0), "#4a7050", rand(3, 7) * s, { kind: "smoke", grav: -60, drag: 0.9 }));
    }
  }

Game.prototype.update = function (dt) {
    this.tickSandboxActivityIdle();
    this.updateVoidAmbient(dt);
    this.tickVoidOverlayTime(dt);
    this.updateRemote(dt);
  }

Game.prototype.updateParticles = function (dt) {
    for (const pt of this.particles) {
      pt.life -= dt;
      pt.vy += pt.grav * dt;
      pt.x += pt.vx * dt; pt.y += pt.vy * dt;
      // drag is authored per-frame at ~60fps; scale to dt so feel is steady.
      const d = Math.pow(pt.drag, dt * 60);
      pt.vx *= d; pt.vy *= d;
    }
    compact(this.particles, p => p.life > 0);
    this.updateBloomRipples?.(dt);
    // expanding shockwave rings (impacts/explosions)
    for (const w of this.shockwaves) w.t += dt;
    compact(this.shockwaves, w => w.t < w.life);
    // short-lived lightning bolts
    for (const b of this.beams) b.t += dt;
    compact(this.beams, b => b.t < b.life);
    for (const d of this.dmgPopups) { d.t += dt; d.y -= (d.float || 34) * dt; }
    compact(this.dmgPopups, d => d.t < d.life);
  }

function directDmgPopupMetrics(dmg) {
    const v = Math.max(1, Math.round(dmg));
    const min = 17, max = 28, ref = 90;
    const t = Math.min(1, Math.sqrt(v / ref));
    const sizePx = min + (max - min) * t;
    const big = v >= 120;
    return {
      sizePx,
      strokePx: sizePx * 0.15,
      life: 0.85 + (big ? 0.08 : 0),
      float: 34 + (big ? 3 : 0),
      color: big ? "#fff0b8" : "#ffe27a",
    };
  }

function dotDmgPopupMetrics(dmg) {
    const v = Math.max(1, Math.round(dmg));
    const min = 14, max = 19, ref = 22;
    const t = Math.min(1, Math.sqrt(v / ref));
    const sizePx = min + (max - min) * t;
    return { sizePx, strokePx: sizePx * 0.12, life: 0.6, float: 22, color: "#c8ddf0" };
  }

function healPopupMetrics(dmg) {
    const v = Math.max(1, Math.round(dmg));
    const min = 16, max = 24, ref = 60;
    const t = Math.min(1, Math.sqrt(v / ref));
    const sizePx = min + (max - min) * t;
    return { sizePx, strokePx: sizePx * 0.14, life: 0.85, float: 34, color: "#74f7a0" };
  }

Game.prototype.spawnDmgPopup = function (x, y, val, dot) {
    const v = Math.round(val);
    if (v <= 0) return;
    const m = dot ? dotDmgPopupMetrics(v) : directDmgPopupMetrics(v);
    const jitter = dot ? rand(-3, 3) : rand(-6, 6);
    this.dmgPopups.push({
      x: x + jitter, y: y - 22, val: v, t: 0, life: m.life, heal: false, dot: !!dot,
      sizePx: m.sizePx, strokePx: m.strokePx, float: m.float, color: m.color,
    });
  }

Game.prototype.spawnHealPopup = function (x, y, val) {
    const v = Math.round(val);
    if (v <= 0) return;
    const m = healPopupMetrics(v);
    this.dmgPopups.push({
      x: x + rand(-6, 6), y: y - 22, val: "+" + v, t: 0, life: m.life, heal: true,
      sizePx: m.sizePx, strokePx: m.strokePx, float: m.float, color: m.color,
    });
  }
